var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachmentIcon = function SvgAttachmentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9535_24251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25208 5.58334L5.59474 9.24068C5.04408 9.79134 5.04408 10.6847 5.59474 11.2353C6.14541 11.786 7.03874 11.786 7.58941 11.2353L12.4107 6.41401C13.4207 5.40401 13.4207 3.76668 12.4107 2.75668C11.4007 1.74668 9.76341 1.74668 8.75341 2.75668L3.93208 7.57801C2.46274 9.04734 2.46274 11.4287 3.93208 12.898C5.40141 14.3673 7.78274 14.3673 9.25208 12.898L12.1781 9.97201",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9535_24251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgAttachmentIcon as ReactComponent };
export default __webpack_public_path__ + "attachment-icon.svg";